// Product components for PDP
export { AffirmMessage } from './AffirmMessage';
export type { AffirmMessageProps } from './AffirmMessage';
export { CembraSentence } from './CembraSentence';
export type { CembraSentenceProps } from './CembraSentence';
export { V12Sentence } from './V12Sentence';
export type { V12SentenceProps } from './V12Sentence';
export { OneySentence } from './OneySentence';
export type { OneySentenceProps } from './OneySentence';
export { BuckleSelector } from './BuckleSelector';
export type { BuckleProduct, BuckleSelectorProps } from './BuckleSelector';
// Eyewear-specific components
export { ColorVariantSwitcher } from './ColorVariantSwitcher';
export type { ColorVariantSwitcherProps } from './ColorVariantSwitcher';
export { KeyFeatures } from './KeyFeatures';
export type { KeyFeaturesProps } from './KeyFeatures';
export { PDPHero } from './PdpHero';
export { PdpBreadcrumbsBar } from './PdpBreadcrumbsBar';
export type { PdpBreadcrumbsBarProps } from './PdpBreadcrumbsBar';
// Re-export types
export type { PDPHeroProps } from './PdpHero';
// Product CTA component (for cards and listings)
export { ProductCta } from './ProductCta';
export type { ProductCtaProps } from './ProductCta';
export { ProductGallery } from './ProductGallery';
export type { ProductGalleryProps } from './ProductGallery';
export { ProductInfo } from './ProductInfo';
export type { ProductInfoProps } from './ProductInfo';
export { ProductStory } from './ProductStory';
export type { ProductStoryProps } from './ProductStory';
export { RegisterWatch } from './RegisterWatch';
export type { RegisterWatchProps } from './RegisterWatch';
// Strap-specific components
export { StrapSizeSelector } from './StrapSizeSelector';
export type { StrapSizeSelectorProps } from './StrapSizeSelector';
export { TechnicalData } from './TechnicalData';
export type { TechnicalDataProps } from './TechnicalData';
export { Warranty } from './Warranty';
export type { WarrantyProps } from './Warranty';
